import { Component, h } from '@stencil/core';

@Component({
  tag: 'icon-lock',
  shadow: true,
})
export class IconAlert {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 16 20">
        <path
          d="M7.64 0h.72l.12.02c.6.04 1.2.17 1.77.4a6.41 6.41 0 0 1 3.97 6v2.67h.44c.76 0 1.34.6 1.34 1.36v8.19c0 .15-.03.3-.07.44-.18.56-.69.92-1.3.92H1.29a1.34 1.34 0 0 1-1.24-1L0 18.8v-8.5l.02-.04C.16 9.5.66 9.09 1.4 9.09h.38V6.26a6.22 6.22 0 0 1 2.43-4.93A5.7 5.7 0 0 1 7.15.06l.5-.06Zm3.91 9.09V6.18a3 3 0 0 0-.27-1.25 3.5 3.5 0 0 0-2.94-2.19 3.57 3.57 0 0 0-3.9 3.63V9.1h7.11Z"
          fill="currentColor"
        />
      </svg>
    );
  }
}
